export class FeatureFlags {
    public static readonly SSOLogIn = "SSOLogIn";
    public static readonly GROUPS = 'Groups';
    public static readonly PRODUCTS = 'Products';
    public static readonly PANEL_STATUS = 'ProviderOverridePanelStatus';
}